import React from "react";
import { AppModalButton } from "../../../components/common/AppModalShell";

// Placeholders follow the actual card layout; no provisional skin or identity
// is painted while the public profile and its castle image are loading.
export default function ProfileCardSkeleton({ copy, failed = false, onRetry }) {
  return <>
    <div className="profile-card-skeleton-content" aria-hidden="true">
      <div className="participant-card-status profile-card-skeleton profile-card-skeleton-status" />
      <div className="participant-card-avatar profile-card-skeleton profile-card-skeleton-avatar" />
      <div className="participant-card-identity">
        <span className="participant-card-code profile-card-skeleton profile-card-skeleton-code" />
        <div className="profile-card-skeleton profile-card-skeleton-name" />
        <div className="profile-card-skeleton profile-card-skeleton-city" />
      </div>
      <div className="participant-card-stats profile-card-skeleton-stats">
        {[0, 1, 2, 3].map((slot) => <div key={slot}>
          <span className="profile-card-skeleton profile-card-skeleton-stat-icon" />
          <span><span className="profile-card-skeleton profile-card-skeleton-stat-value" /><span className="profile-card-skeleton profile-card-skeleton-stat-caption" /></span>
        </div>)}
      </div>
      <div className="participant-card-awards">
        <div className="profile-card-skeleton profile-card-skeleton-heading" />
        <div className="participant-card-badges">{[0, 1, 2].map((slot) => <div key={slot} className="profile-card-skeleton-badge">
          <span className="profile-card-skeleton profile-card-skeleton-badge-icon" /><span className="profile-card-skeleton profile-card-skeleton-badge-caption" />
        </div>)}</div>
      </div>
      <div className="participant-card-vault-action">
        <div className="profile-card-skeleton profile-card-skeleton-vault" />
        <div className="profile-card-skeleton profile-card-skeleton-hint" />
      </div>
      <div className="participant-card-safety profile-card-skeleton-safety">
        <span className="profile-card-skeleton" /><span className="profile-card-skeleton" />
      </div>
    </div>
    <div className="profile-card-skeleton-feedback" role={failed ? "alert" : "status"} aria-live="polite">
      {!failed && <span className="profile-card-loading-spinner" aria-hidden="true" />}
      <p>{failed ? copy.profileUnavailable : copy.profileLoading}</p>
      {failed && <AppModalButton variant="secondary" onClick={onRetry}>{copy.retry}</AppModalButton>}
    </div>
  </>;
}
